<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-6">
          <h1>Banner Lists</h1>
        </div>
        <div class="col-xs-6">
          <router-link :to="{ path: 'add-banner' }" class="btn btn-sm btn-add">
            <i class="fa fa-plus-square"></i> Add Banner
          </router-link>
          <a class="btn btn-sm btn-add refresh" @click="refreshNow">
            <i class="fa fa-refresh"></i> Refresh
          </a>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="row form">
        <div class="col-xs-6 col-sm-2 form-group">
          <select
            title=""
            name="status"
            id="status"
            v-model="status"
            v-select="status"
            class="form-control input-sm select2"
            @change="filterBannerList()"
          >
            <option value="">All</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>
        <div class="col-xs-6 col-sm-2 form-group">
          <select
            title=""
            name="limit"
            id="limit"
            v-model="display_limit"
            v-select="display_limit"
            class="form-control input-sm select2"
            @change="dopagination(0)"
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="box" id="pagination">
            <div class="box-header">
              <h3 class="box-title">
                Total : {{ totalData }} Showing {{ dispplayFrom }} to
                {{ dispplayTo }}
                <span class="pull-right noOfData">{{ totalData }}</span>
              </h3>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-0024 table-bordered table-striped">
                  <thead>
                    <tr>
                      <th class="tdCenter tdSN">SN</th>
                      <th class="tdCenter">Offer Or Slider Name</th>
                      <th class="tdCenter">Website Img</th>
                      <th class="tdCenter">Subscriber Type</th>
                      <th class="tdCenter">Trial Selection</th>
                      <th class="tdCenter">Subscription Packages</th>
                      <th class="tdCenter">Countries</th>
                      <th class="tdCenter">Days before expired</th>
                      <th class="tdCenter">Loyal Member</th>
                      <th class="tdCenter">Start Time</th>
                      <th class="tdCenter">End Time</th>
                      <th class="tdCenter">Status</th>
                      <th class="tdCenter">Slider Img</th>
                      <th class="tdCenter">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in bannerList" :key="data.id">
                      <td class="tdCenter tdSN">{{ parseInt(sl) + index }}</td>
                      <td class="">{{ data.banner_name }}</td>
                      <td class="tdCenter">
                        <img
                          v-if="data.website_img"
                          :src="data.website_img"
                          class="img-responsive img-thumbnail"
                          style="max-height: 80px"
                        />
                      </td>
                      <td class="">
                        {{ getSubscriberTypeString(data.user_type) }}
                      </td>
                      <td class="">
                        {{
                          data.trial_selection_type
                            ? includeExclueTypeArray[data.include_exclude_type]
                            : "N/A"
                        }}
                      </td>

                      <td class="">
                        {{
                          data.subscription_types_name
                            ? data.subscription_types_name
                            : "All"
                        }}
                      </td>
                      <td class="">
                        {{ data.country ? data.country : "All" }}
                      </td>
                      <td class="">
                        {{
                          data.days_before_expired
                            ? data.days_before_expired
                            : "N/A"
                        }}
                      </td>
                      <td class="">
                        {{ data.is_show_to_loyal_member == 1 ? "Yes" : "No" }}
                      </td>
                      <td>
                        {{
                          data.started_at
                            ? new Date(data.started_at)
                                .toISOString()
                                .slice(0, 10)
                            : "N/A"
                        }}
                      </td>
                      <td>
                        {{
                          data.ended_at
                            ? new Date(data.ended_at).toISOString().slice(0, 10)
                            : "N/A"
                        }}
                      </td>

                      <td class="tdCenter">
                        <span
                          v-if="
                            data.status == 2 &&
                            data.pendingSliderImages == 0 &&
                            data.sliderImages == 0
                          "
                          class="btn-warning p-1"
                        >
                          Please add images to this banner in order to get it approved.
                        </span>
                        <span
                          v-else-if="
                            data.status == 2 &&
                            data.pendingSliderImages == 0 &&
                            data.sliderImages > 0
                          "
                          class="btn-warning p-1"
                        >
                          Waiting for approval of new changes
                        </span>
                        <span
                          v-else-if="
                            data.status == 2 &&
                            data.pendingSliderImages > 0 &&
                            data.sliderImages == 0
                          "
                          class="btn-warning p-1"
                        >
                          Waiting for approval
                        </span>
                        <span
                          v-else-if="
                            data.status == 1 && data.pendingSliderImages > 0
                          "
                          class="btn-warning p-1"
                        >
                          Waiting for approval of new images
                        </span>
                        <span
                          v-else-if="data.status == 3"
                          class="text-danger bg-red"
                          >Rejected</span
                        >
                        <span
                          v-else
                          :class="{
                            'label label-danger':
                              data.status == 0 || data.status == 3,
                            'label label-success': data.status == 1,
                          }"
                        >
                          {{
                            data.status == 0
                              ? "Inactive"
                              : data.status == 1
                              ? "Activated"
                              : "Rejected"
                          }}
                        </span>
                      </td>
                      <td class="tdCenter">
                        <template
                          v-if="
                            data.status == 0 ||
                            data.status == 1 ||
                            data.status == 2
                          "
                        >
                          <router-link
                            :to="{
                              name: 'BannerImage',
                              params: { id: data.id, name: data.banner_name },
                            }"
                            class="btn btn-sm btn-sm2"
                            :class="
                              data.sliderImages > 0
                                ? 'btn-success'
                                : 'btn-warning'
                            "
                            style="padding: 1px 2px"
                          >
                            <i
                              :class="
                                data.sliderImages > 0
                                  ? 'ion ion-compose'
                                  : 'ion ion-ios-plus-outline'
                              "
                            ></i>
                            Images<span v-if="data.sliderImages > 0">
                              ({{ data.sliderImages }})</span
                            >
                          </router-link>
                        </template>

                        <template v-else>
                          <span
                            class="btn btn-sm btn-sm2 btn-warning"
                            style="
                              padding: 1px 2px;
                              pointer-events: none;
                              opacity: 0.6;
                            "
                            title="Approval required"
                          >
                            <i class="ion ion-ios-plus-outline"></i>
                            Images
                          </span>
                        </template>
                      </td>
                      <td class="tdCenter">
                        <!-- <a
                          :href="`/:panel/edit-banner/${data.id}`"
                          title=""
                          class="btn btn-sm btn-primary btn-sm2"
                          style="padding: 1px 2px"
                        >
                          <i class="fa fa-edit"></i> Edit
                        </a> -->
                        <template v-if="data.status in [3, 2]">
                          <router-link
                            :to="{
                              name: 'EditBanner',
                              params: { id: data.id, name: data.banner_name },
                            }"
                            class="btn btn-sm btn-primary btn-sm2"
                            style="padding: 1px 2px"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </router-link>
                        </template>
                        <template v-else>
                          <span
                            class="btn btn-sm btn-primary btn-sm2"
                            style="
                              padding: 1px 2px;
                              pointer-events: none;
                              opacity: 0.6;
                            "
                            title="Approval required"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </span>
                        </template>
                      </td>
                    </tr>

                    <tr v-if="totalData == 0">
                      <td colspan="12" class="tdCenter" style="padding: 30px 0">
                        <b>No Records Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="pagination" v-if="last_page > 1">
              <a
                v-if="prev_page_url"
                href="#"
                @click="dopagination(prevPage)"
                class="next"
              >
                « Previous
              </a>
              <span v-else class="disabled">« Previous</span>
              <span v-if="last_page > max_display_pagination">
                <span v-for="index in last_page">
                  <span v-if="index == 1 || index == 2">
                    <span class="current" v-if="index == current_page">
                      {{ index }}
                    </span>
                    <span v-else>
                      <a href="#" @click="dopagination(index)">
                        {{ index }}
                      </a>
                    </span>
                    <span v-if="index == 2 && firstDotted">..</span>
                  </span>
                  <span v-if="randomPageNumber.includes(index)">
                    <span class="current" v-if="index == current_page">
                      {{ index }}
                    </span>
                    <span v-else>
                      <a href="#" @click="dopagination(index)">
                        {{ index }}
                      </a>
                    </span>
                  </span>
                  <span v-if="index == last_page || index == last_page - 1">
                    <span v-if="index == last_page - 1 && lastDotted">
                      ..
                    </span>
                    <span class="current" v-if="index == current_page">
                      {{ index }}
                    </span>
                    <span v-else>
                      <a href="#" @click="dopagination(index)">
                        {{ index }}
                      </a>
                    </span>
                  </span>
                </span>
              </span>
              <span v-else>
                <span v-for="index in last_page">
                  <span class="current" v-if="index == current_page">
                    {{ index }}
                  </span>
                  <span v-else>
                    <a href="#" @click="dopagination(index)">{{ index }}</a>
                  </span>
                </span>
              </span>
              <a
                v-if="next_page_url"
                href="#"
                @click="dopagination(nextPage)"
                class="next"
              >
                Next »
              </a>
              <span v-else class="disabled">Next »</span>
            </div>
            <div class="box-footer">
              <input
                type="hidden"
                name="limit"
                id="limit"
                value="<?php echo $limit ?>"
              />
              <input
                type="hidden"
                name="startoffset"
                id="startoffset"
                value="<?php echo $startoffset ?>"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
// import { reduce } from "core-js/core/array";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import router from "../router";

export default {
  components: {
    vSelect,
  },
  name: "BannerList",
  data() {
    return {
      bannerList: [],
      dispplayFrom: 0,
      dispplayTo: 0,
      display_limit: 50,
      totalData: 0,
      prev_page_url: false,
      next_page_url: false,
      last_page: 1,
      current_page: null,
      max_display_pagination: 9,
      randomPageNumber: {},
      firstDotted: false,
      lastDotted: false,
      prevPage: "",
      nextPage: "",
      includeExclueTypeArray: {
        1: "Include",
        2: "Exclude",
      },
      subscriberTypeArray: {
        1: "Reseller PIN",
        2: "Online Premium",
        3: "Online Free",
      },
      statusArray: {
        0: '<span class="label label-danger"> Inactive </span>',
        1: '<span class="label label-success"> Activated </span>',
        3: '<span class="label label-danger"> Rejected </span>',
      },
      status: "",
    };
  },
  mounted() {
    $(".select2").select2();
  },
  created() {
    this.filterBannerList();
  },
  methods: {
    getSubscriberTypeString(userType) {
      if (!userType) return "All";
      const selectedUserTypes = userType.split(",");
      const filtered = selectedUserTypes
        .map((type) => this.subscriberTypeArray[type])
        .filter(Boolean);
      return filtered.length ? filtered.join(", ") : "All";
    },
    dopagination(page_no = "") {
      loader.show();
      var rootObject = this;

      let querystr = "paginate=" + this.display_limit;
      if (this.status) {
        querystr += "&status=" + this.status;
      }
      if (page_no > 0) {
        querystr += "&page=" + page_no;
      } else {
        querystr += "&page=1";
      }

      axios
        .get("/get-banner-list?" + querystr)
        .then(function (response) {
          rootObject.populateBannerListData(response?.data);
          loader.hide();
        })
        .catch(function (error) {
          console.log(error, "error");
          let alertmessage = "";
          for (var prop in error?.response?.data) {
            alertmessage += " " + error.response.data[prop];
          }

          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },
    populateBannerListData(response) {
      this.sl = parseInt(response.data.from);
      this.bannerList = response.data.data;
      this.totalData = response.data.total;
      this.dispplayFrom = response.data.from;
      this.dispplayTo = response.data.to;
      this.display_limit = response.data.per_page;
      this.paginationGenerate(response);
      loader.hide();
    },
    paginationGenerate(response) {
      console.log(response, "response");
      this.prev_page_url = response.data.prev_page_url;
      this.next_page_url = response.data.next_page_url;
      this.last_page = response.data.last_page;
      this.current_page = response.data.current_page;
      this.randomPageNumber = [];
      this.firstDotted = false;
      this.lastDotted = false;
      this.prevPage = this.current_page - 1;
      this.nextPage = this.current_page + 1;
      let countableOtherPages = this.max_display_pagination - 4;
      if (this.current_page == 1 || this.current_page == 2) {
        for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) {
          this.randomPageNumber?.banner(i);
        }
        this.lastDotted = true;
      } else if (
        this.current_page == this.last_page ||
        this.current_page == this.last_page - 1
      ) {
        let endPage = this.last_page - 2;
        for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
          this.randomPageNumber?.banner(i);
        }
        this.firstDotted = true;
      } else {
        let interval = parseInt(countableOtherPages / 2);
        if (this.current_page <= interval + 3) {
          for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) {
            this.randomPageNumber.banner(i);
          }
          this.lastDotted = true;
        } else if (this.current_page >= this.last_page - (interval + 2)) {
          let endPage = this.last_page - 2;
          for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
            this.randomPageNumber.banner(i);
          }
          this.firstDotted = true;
        } else {
          for (
            let i = this.current_page;
            i <= this.current_page + interval;
            i++
          ) {
            this.randomPageNumber.banner(i);
          }

          for (
            let i = this.current_page - 1;
            i >= this.current_page - interval;
            i--
          ) {
            this.randomPageNumber.banner(i);
          }
        }
      }
      //console.log(this.randomPageNumber);
    },
    resendBanner(id, status) {
      var rootObject = this;
      var msg = "Are you sure you want to resend this banner notification?";
      if (status == 3) {
        msg =
          "This banner notification has no users to send! Please check view details";
        $.alert(msg);
        return;
      }

      $.confirm({
        title: "Confirm!",
        content: msg,
        buttons: {
          yes: function () {
            loader.show();

            var config = {
              headers: { "Content-Type": "multipart/form-data" },
            };
            var form = new FormData();
            form.append("id", id);
            axios
              .post("/resend-banner", form, config)
              .then(function (response) {
                if (response.data.status_code == 200) {
                  rootObject.filterBannerList();
                }
                loader.hide();
              })
              .catch(function (error) {
                rootObject.com_errorHandel(error);
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += " " + error.response.data[prop];
                }
                //console.log(alertmessage);
                loader.hide();
                $.alert(alertmessage);
              });
          },
          no: function () {
            return;
          },
        },
      });
    },
    filterBannerList() {
      let querystr = "paginate=" + this.display_limit;
      if (this.status) {
        querystr += "&status=" + this.status;
      }

      loader.show();
      axios
        .get("/get-banner-list?" + querystr)
        .then((response) => {
          this.populateBannerListData(response.data);
        })
        .catch((error) => {
          loader.hide();
        });
    },
    refreshNow() {
      this.status = "";
      this.display_limit = 50;
      this.filterBannerList();
    },
  },
};
</script>

<style scoped>
.text-danger {
  color: red;
}
.status-succeed {
  color: #28a745; /* Green for success */
  font-weight: bold;
}

.status-user-not-found {
  color: #ffc107; /* Yellow for user not found */
  font-weight: bold;
}

.status-failed {
  color: #dc3545; /* Red for failure */
  font-weight: bold;
}
</style>
